<ng-container *appNotesAppContext>
<!--
  #1016 iteration 1: notes has no top bar. The page starts at y = 0, so this wrapper is notes' own —
  `.under-nav-bar` is shared by the two layouts that still carry a 48 px `app-nav-bar` (contacts,
  files) plus the three `app-base-nav-bar` ones (settings, admin, spaces), and must keep its offset
  for them.

  #1146 round 1: the rail's OWN split-view is gone. It is a fixed 266 px column now — no gutter, no
  drag, no magnetic width, and so no `[collapsedSize]`, `[shadow]`, `[magneticSize]`, `[withIcon]` or
  `[iconTop]` for it either: the reopen chevron those last two positioned has no host left. The rail
  component owns its own parked width; the host owns the docked one and passes it below.

  The NOTES LIST keeps its splitter, and keeps `[iconTop]="38"` with it: the split-view's own reopen
  chevron defaults to `top: -10px` from its own top edge, which under the old bar landed at 38 by
  accident and from y = 0 would draw half above the window.
-->
<div class="notes-shell">
  <!--
    The shell sits OUTSIDE `*stchSpaceRerender` on purpose: the bell's subscription, the app switcher
    and the search input survive a workspace switch exactly as they did in the bar. Only the rail
    below is torn down and rebuilt, which is what it did before.
  -->
  <app-collapsible-rail-shell class="notes-rail" [app]="app">
    <stch-side-bar-teams
      *stchSpaceRerender
      [template]="sidebarTemplate"
      [splitViewKey]="SidebarSplitViewKey.notes"
    />
  </app-collapsible-rail-shell>

  <app-split-view
    class="notes-rest"
    side="left"
    key="notesList"
    [collapsedSize]="25"
    [shadow]="true"
    [magneticSize]="300"
    [withIcon]="true"
    [iconTop]="38"
  >
    <app-notes-list-container
      split-left-pane
      *stchSpaceRerender
      class="list shadow-lg"
    />

    <div class="full-form shadow-lg" split-right-pane>
      <app-notes-main-view *stchSpaceRerender />
    </div>
  </app-split-view>

  <ng-template #sidebarTemplate let-team="team">
    <app-notes-side-bar [team]="team"/>
  </ng-template>
</div>
</ng-container>
